module.exports = __webpack_public_path__ + "media/images/countryrect/crimea-e676b882b8b60e5d5f8122af2f4ee038.svg";